import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Rights } from 'src/app/models/enums/rights';
import { MemoryService } from 'src/app/services/memory.service';
import { MenuITemAction } from '../../advanced-gridview/models/menu-item-action';
import { RowClickEvent } from '../../advanced-gridview/models/row-click-event';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { ListItem } from '../../filters/models/list-item';

@Component({
    template: '',
    standalone: false
})
export class DefaultTreeItemComponent<T> {
    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'Supprimer'.
     */
    @Output()
    itemDeleted: EventEmitter<T> = new EventEmitter();

    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'Réinitialiser'.
     */
    @Output()
    itemReseted: EventEmitter<T> = new EventEmitter();

    /**
     * Emis lorsque l'utilisateur sélectionne un élément.
     */
    @Output()
    itemSelected: EventEmitter<T> = new EventEmitter();

    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'Editer' d'un élémenent.
     */
    @Output()
    itemEdited: EventEmitter<T> = new EventEmitter();

    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'Dupliquer' d'un élémenent.
     */
    @Output()
    itemDuplicated: EventEmitter<T> = new EventEmitter();

    /**
     * Emis lorsque l'utilisateur clique sur le menu contextuel 'Consulter' d'un élémenent.
     */
    @Output()
    itemDisplayed: EventEmitter<T> = new EventEmitter();

    /**
     * Elements du menu contextuel du composant AdvancedGridview.
     */
    public menuItems: ListItem<MenuITemAction>[] = [new ListItem(MenuITemAction.Read, 'Consulter')];

    constructor(
        public dialog: MatDialog,
        protected memoryService: MemoryService
    ) {}

    /**
     * Ajoute un élément au menu contextuel.
     * @param menuItemLabel : Libellé de l'élément.
     * @param menuItemAction : Action lié à l'élément.
     * @param neededRight : Droit necessaire pour avoir acces à cet élément.
     */
    protected AddMenuItem(menuItemLabel: string, menuItemAction: MenuITemAction, neededRight: Rights) {
        if (this.memoryService.getConnectedUser().hasRight(neededRight)) {
            this.menuItems.push(new ListItem(menuItemAction, menuItemLabel));
        }
    }

    protected displayDeleteConfirmationDialog(confirmationText: string, item: T) {
        // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            maxWidth: '400px',
            data: {
                title: 'Confirmation de suppression',
                message: confirmationText,
            },
            panelClass: 'empty-dialog',
        });

        // Attente de la réponse de la boite de dialogue de confirmation
        dialogRef.afterClosed().subscribe((dialogResult) => {
            if (dialogResult) {
                // Suppression effective du client.
                this.itemDeleted.emit(item);
            }
        });
    }

    protected displayResetConfirmationDialog(confirmationText: string, item: T) {
        // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            maxWidth: '400px',
            data: {
                title: 'Confirmation de réinitialisation',
                message: confirmationText,
            },
            panelClass: 'empty-dialog',
        });

        // Attente de la réponse de la boite de dialogue de confirmation
        dialogRef.afterClosed().subscribe((dialogResult) => {
            if (dialogResult) {
                // Suppression effective du client.
                this.itemReseted.emit(item);
            }
        });
    }

    /**
     * Appellé lorsque l'utilisateur clique sur une ligne de la liste.
     * @param event : Événement retourné par la liste.
     */
    public onSelection(event: RowClickEvent<T>): void {
        this.itemSelected.emit(event.context);
    }
}
